import React, { Fragment, useContext } from 'react';
import { useLocation, Link, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { WidthContext } from '../../../contexts/WidthContextProvider';
import { Heading, Subtitle, Body } from '../../modules/Typography';
import Paper from '../../modules/Paper';

import CPLParser from './CPL-Parser';
import NamingSpecDecoderRing from './Naming-Spec-Decoder-Ring';
import ST2086Extractor from './2086_Extractor';
import DoviChecker from './Dovi-Checker';
import NamingConventionLookup from './naming_convention_lookup';
import LanguageDecoderRing from './language-decoder-ring';
import DigitalCinemaNamingDecoder from './digital-cinema-naming-decoder';
import SafeAreaCalculator from './safe-area-calculator';

const nestedRoutes = {
    'Mastering Toolbox': [
        { path: 'cpl-parser', component: <CPLParser />, name: 'IMF CPL Parser' },
        { path: 'naming-spec-decoder-ring', component: <NamingSpecDecoderRing />, name: 'Naming Spec Decoder Ring' },
        { path: 'st2086-extractor', component: <ST2086Extractor />, name: 'ST2086 Extractor' },
        { path: 'dovi-checker', component: <DoviChecker />, name: 'Dolby Vision XML Checker' },
        { path: 'naming-convention-lookup', component: <NamingConventionLookup />, name: 'Naming Convention Lookup' },
        { path: 'language-decoder-ring', component: <LanguageDecoderRing />, name: 'Language Table Decoder Ring' },
        { path: 'digital-cinema-naming-decoder', component: <DigitalCinemaNamingDecoder />, name: 'Digital Cinema Naming Decoder' },
        { path: 'safe-area-calculator', component: <SafeAreaCalculator />, name: 'Safe Area Calculator' }
    ]
};

const Tools = props => {
    const url = useLocation().pathname;

    const selectedPath = url.replace(/^\/tools\/?/, '').replace(/\/$/, '');
    var selectedComponent = <CPLParser />;
    Object.keys(nestedRoutes).map(key => {
        nestedRoutes[key].map((route, idx) => {
            if (selectedPath === route.path) {
                selectedComponent = route.component;
            }
        });
    });

    const { isMobile } = useContext(WidthContext);

    return (
        <main>
            <Helmet><title>Disney Media Tech Specs | Tools</title></Helmet>
            <Heading number={5} heavy block className='tools__title'>Tools</Heading>
            <Body number={1} block faded className='tools__intro'>
                The Mastering Toolbox provides a group of utilities for quick checks and reviews.
                These tools do not supersede or guarantee a passing QC, nor do they generate
                convention names or files to spec. They report what they see to help users sort
                through extensive specifications.
            </Body>
            
            <Paper className='tools__section' elevation={6}>
                {!isMobile &&
                <aside className='tools__aside'>
                    <nav>
                        {
                            Object.keys(nestedRoutes).map(key => {
                                return (
                                    <Fragment key={key}>
                                        <Subtitle number={3} className=''>{key}</Subtitle>
                                        <ul className='tools__nav__list'>
                                            {
                                                nestedRoutes[key].map((route, idx) => {
                                                    return (
                                                        <li className='tools__nav__list-item' key={idx}>
                                                            <Link className='Typography--subtitle1' to={`../../tools/${route.path}`}>{route.name}</Link>
                                                        </li>
                                                    );
                                                })
                                            }
                                        </ul>
                                    </Fragment>
                                );
                            })
                        }
                    </nav>
                </aside>}

                <main style={{ width: '100%' }}>
                    <Routes>
                        <Route path='/' element={selectedComponent} exact />
                    </Routes>
                </main>
            </Paper>
        </main>
    );
};

export default Tools;
